import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { ShowView } from "@/components/UnderConstructionView/ShowView";
import { PageFrame } from "@/layouts/page-frame";

const UnderConstructionPage = () => {
  const title = t("web.under_construction.show.title");
  const description = t("web.under_construction.show.description");

  return (
    <PageFrame>
      <Head title={t("web.under_construction.show.meta_title")}>
        <meta name="description" content={t("web.under_construction.show.meta_description")} />
      </Head>
      <div className="flex flex-1 items-center justify-center">
        <ShowView title={title} description={description} />
      </div>
    </PageFrame>
  );
};

export default UnderConstructionPage;
